import icons from "../../assets/icons";

const allIcons = icons;

const Icon = ({ id, ...props }) => {
	const selectedIcon = allIcons[id];
	return selectedIcon ? selectedIcon(props) : null;
};

export default Icon;
